import React, { forwardRef } from 'react'

import clsx from 'clsx'

import styles from './Grid.module.scss'

const getItemClassNames = (breakpoints = {}) => {
  const classNames = Object.keys(breakpoints)
    .filter(key => breakpoints[key])
    .reduce((acc, curr) => {
      return [...acc, `col-${curr}-${breakpoints[curr]}`]
    }, [])

  return classNames
}

/** @type {import("./types").default} */
const Grid = forwardRef(
  (
    {
      alignItems,
      justifyContent,
      component,
      container,
      className,
      item,
      spacing,
      xs,
      sm,
      md,
      lg,
      children,
      maxWidth,
      zeroMinWidth,
      ...otherProps
    },
    ref
  ) => {
    const itemClassNames = getItemClassNames({ xs, sm, md, lg })
      .map(cName => styles[cName])
      .join(' ')

    const classNames = clsx({
      [styles.row]: container,
      [styles[`spacing-${spacing}`]]: spacing,
      [itemClassNames]: item,
      [styles['zero-min-width']]: zeroMinWidth,
    })

    const Component = component || 'div'

    return (
      <Component
        ref={ref}
        className={clsx('Grid', className, classNames)}
        style={{
          justifyContent: justifyContent,
          alignItems: alignItems,
        }}
        {...otherProps}
        {...(component && maxWidth ? { maxWidth } : {})}
      >
        {children}
      </Component>
    )
  }
)

export default Grid
